import { render } from "./ColorSwatch.vue?vue&type=template&id=72ca34a7"
import script from "./ColorSwatch.vue?vue&type=script&lang=js"
export * from "./ColorSwatch.vue?vue&type=script&lang=js"

import exportComponent from "/Users/jjviglio/OpenMCT/openmct/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__